module.exports = __webpack_public_path__ + "static/media/search-notification-close.e1ab3657.svg";